<ziro-explorer
  class="w-100"
  [config]="config()"
  [activeGreetingAudioUrl]="activeGreetingAudioUrl()"
  [activeGreetingAudioLoadingUrl]="activeGreetingAudioLoadingUrl()"
  [activeGreetingAudioDownloadUrl]="activeGreetingAudioDownloadUrl()"
  (playGreetingAudio)="playGreetingAudio.emit($event)"
  (stopGreetingAudio)="stopGreetingAudio.emit()"
  (downloadGreetingAudio)="downloadGreetingAudio.emit($event)"
  data-automation="auto-attendants-report-explorer"
></ziro-explorer>
